var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('cs-dialog', {
    model: {
      value: _vm.isShownDialog,
      callback: function callback($$v) {
        _vm.isShownDialog = $$v;
      },
      expression: "isShownDialog"
    }
  }, [_c('dialog-list-layout', [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.title
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('transactions.status')))])]), _c('div', {
    class: _vm.$style.content
  }, _vm._l(_vm.statusesList, function (status, idx) {
    return _c('div', {
      key: idx,
      class: _vm.$style.panel
    }, [_c('toggle-panel', {
      attrs: {
        "title": status.description
      },
      on: {
        "click": function click($event) {
          return _vm.handleChangeByIdx(idx);
        }
      },
      model: {
        value: status.value,
        callback: function callback($$v) {
          _vm.$set(status, "value", $$v);
        },
        expression: "status.value"
      }
    }, [_c(status.icon.component, {
      tag: "component",
      attrs: {
        "slot": "icon",
        "fill": status.icon.fill
      },
      slot: "icon"
    })], 1)], 1);
  }), 0), _c('div', {
    class: _vm.$style.footer
  }, [_c('div', {
    class: _vm.$style.submit
  }, [_c('cs-button', {
    attrs: {
      "width": "100%"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.save')) + " ")])], 1), _c('cs-button', {
    attrs: {
      "type": "transparent"
    },
    on: {
      "click": function click($event) {
        _vm.isShownDialog = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }